/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routing/routes/__root'
import { Route as StaticLayoutImport } from './routing/routes/_static/_layout'
import { Route as CmsLayoutImport } from './routing/routes/_cms/_layout'
import { Route as StaticUtloggadImport } from './routing/routes/_static/utloggad'
import { Route as StaticLoggaUtImport } from './routing/routes/_static/logga-ut'
import { Route as StaticEjMedlemImport } from './routing/routes/_static/ej-medlem'
import { Route as CmsSplatImport } from './routing/routes/_cms/$'

// Create/Update Routes

const StaticLayoutRoute = StaticLayoutImport.update({
  id: '/_static',
  getParentRoute: () => rootRoute,
} as any)

const CmsLayoutRoute = CmsLayoutImport.update({
  id: '/_cms',
  getParentRoute: () => rootRoute,
} as any)

const StaticUtloggadRoute = StaticUtloggadImport.update({
  id: '/utloggad',
  path: '/utloggad',
  getParentRoute: () => StaticLayoutRoute,
} as any)

const StaticLoggaUtRoute = StaticLoggaUtImport.update({
  id: '/logga-ut',
  path: '/logga-ut',
  getParentRoute: () => StaticLayoutRoute,
} as any)

const StaticEjMedlemRoute = StaticEjMedlemImport.update({
  id: '/ej-medlem',
  path: '/ej-medlem',
  getParentRoute: () => StaticLayoutRoute,
} as any)

const CmsSplatRoute = CmsSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => CmsLayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_cms': {
      id: '/_cms'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof CmsLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_static': {
      id: '/_static'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StaticLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_cms/$': {
      id: '/_cms/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof CmsSplatImport
      parentRoute: typeof CmsLayoutImport
    }
    '/_static/ej-medlem': {
      id: '/_static/ej-medlem'
      path: '/ej-medlem'
      fullPath: '/ej-medlem'
      preLoaderRoute: typeof StaticEjMedlemImport
      parentRoute: typeof StaticLayoutImport
    }
    '/_static/logga-ut': {
      id: '/_static/logga-ut'
      path: '/logga-ut'
      fullPath: '/logga-ut'
      preLoaderRoute: typeof StaticLoggaUtImport
      parentRoute: typeof StaticLayoutImport
    }
    '/_static/utloggad': {
      id: '/_static/utloggad'
      path: '/utloggad'
      fullPath: '/utloggad'
      preLoaderRoute: typeof StaticUtloggadImport
      parentRoute: typeof StaticLayoutImport
    }
  }
}

// Create and export the route tree

interface CmsLayoutRouteChildren {
  CmsSplatRoute: typeof CmsSplatRoute
}

const CmsLayoutRouteChildren: CmsLayoutRouteChildren = {
  CmsSplatRoute: CmsSplatRoute,
}

const CmsLayoutRouteWithChildren = CmsLayoutRoute._addFileChildren(
  CmsLayoutRouteChildren,
)

interface StaticLayoutRouteChildren {
  StaticEjMedlemRoute: typeof StaticEjMedlemRoute
  StaticLoggaUtRoute: typeof StaticLoggaUtRoute
  StaticUtloggadRoute: typeof StaticUtloggadRoute
}

const StaticLayoutRouteChildren: StaticLayoutRouteChildren = {
  StaticEjMedlemRoute: StaticEjMedlemRoute,
  StaticLoggaUtRoute: StaticLoggaUtRoute,
  StaticUtloggadRoute: StaticUtloggadRoute,
}

const StaticLayoutRouteWithChildren = StaticLayoutRoute._addFileChildren(
  StaticLayoutRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof StaticLayoutRouteWithChildren
  '/$': typeof CmsSplatRoute
  '/ej-medlem': typeof StaticEjMedlemRoute
  '/logga-ut': typeof StaticLoggaUtRoute
  '/utloggad': typeof StaticUtloggadRoute
}

export interface FileRoutesByTo {
  '': typeof StaticLayoutRouteWithChildren
  '/$': typeof CmsSplatRoute
  '/ej-medlem': typeof StaticEjMedlemRoute
  '/logga-ut': typeof StaticLoggaUtRoute
  '/utloggad': typeof StaticUtloggadRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_cms': typeof CmsLayoutRouteWithChildren
  '/_static': typeof StaticLayoutRouteWithChildren
  '/_cms/$': typeof CmsSplatRoute
  '/_static/ej-medlem': typeof StaticEjMedlemRoute
  '/_static/logga-ut': typeof StaticLoggaUtRoute
  '/_static/utloggad': typeof StaticUtloggadRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '' | '/$' | '/ej-medlem' | '/logga-ut' | '/utloggad'
  fileRoutesByTo: FileRoutesByTo
  to: '' | '/$' | '/ej-medlem' | '/logga-ut' | '/utloggad'
  id:
    | '__root__'
    | '/_cms'
    | '/_static'
    | '/_cms/$'
    | '/_static/ej-medlem'
    | '/_static/logga-ut'
    | '/_static/utloggad'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  CmsLayoutRoute: typeof CmsLayoutRouteWithChildren
  StaticLayoutRoute: typeof StaticLayoutRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  CmsLayoutRoute: CmsLayoutRouteWithChildren,
  StaticLayoutRoute: StaticLayoutRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_cms",
        "/_static"
      ]
    },
    "/_cms": {
      "filePath": "_cms/_layout.tsx",
      "children": [
        "/_cms/$"
      ]
    },
    "/_static": {
      "filePath": "_static/_layout.tsx",
      "children": [
        "/_static/ej-medlem",
        "/_static/logga-ut",
        "/_static/utloggad"
      ]
    },
    "/_cms/$": {
      "filePath": "_cms/$.tsx",
      "parent": "/_cms"
    },
    "/_static/ej-medlem": {
      "filePath": "_static/ej-medlem.tsx",
      "parent": "/_static"
    },
    "/_static/logga-ut": {
      "filePath": "_static/logga-ut.tsx",
      "parent": "/_static"
    },
    "/_static/utloggad": {
      "filePath": "_static/utloggad.tsx",
      "parent": "/_static"
    }
  }
}
ROUTE_MANIFEST_END */
